var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = void 0;

var React = __importStar(require("react"));

var IconButton_1 = __importDefault(require("../IconButton"));
/**
 * ## Importing
 *
 * ```
 * import { ToggleButton } from '@naturacosmeticos/natds-web';
 * ```
 */


exports.ToggleButton = React.forwardRef(function (props, ref) {
  var _a = props.checked,
      checked = _a === void 0 ? false : _a,
      iconOff = props.iconOff,
      iconOn = props.iconOn,
      onClick = props.onClick,
      otherProps = __rest(props, ["checked", "iconOff", "iconOn", "onClick"]);

  var _b = React.useState(checked),
      checkedState = _b[0],
      onToggle = _b[1];

  var icon = checkedState ? iconOn : iconOff;
  React.useEffect(function () {
    return onToggle(checked);
  }, [checked]);

  var handleClick = function handleClick(event) {
    onToggle(!checkedState);

    if (onClick) {
      onClick(event, checkedState);
    }
  };

  return React.createElement(IconButton_1.default, __assign({
    onClick: handleClick
  }, otherProps, {
    ref: ref
  }), icon);
});
exports.ToggleButton.displayName = "ToggleButton";
exports.default = exports.ToggleButton;